import { LitElement, html, css, unsafeCSS, property } from 'lit-element';

import numberComparisonTableStyles from './number-comparison-table.scss';
import HighlightRule from '../../enums/highlight-rule';
import { StratusStatsCardComponentTemplateModel } from '../../models/components/StratusStatsCardComponentTemplateModel';

class NumberAnimationModel {
    public Number: number;
    public CurrentNumber: number;
    public Step: number;
    public Control: HTMLElement;
    public Animate: Function;
    public Suffix: string;

    constructor(number, control, animate) {
        this.Number = number.replace('%', '');
        this.Control = control;
        this.CurrentNumber = 0;
        this.Step = parseInt((Math.ceil(this.Number / 30)).toFixed(0));
        this.Animate = animate;
        this.Suffix = number.includes('%') ? '%' : '';
    }
}

export class NumberComparisonTable extends LitElement {
    private _data: StratusStatsCardComponentTemplateModel;
    private _onClick: Function;
    private _playlistClickThrough: boolean;

    constructor(data: StratusStatsCardComponentTemplateModel, playlistClickThrough: boolean, onClick: Function) {
        super();

        this._data = data;
        this._onClick = onClick;
        this._playlistClickThrough = playlistClickThrough;
    }

    static get styles() {
        return [
            css`${unsafeCSS(numberComparisonTableStyles)}`
        ]
    }

    firstUpdated() {
        let homeTeamControl = this.shadowRoot.querySelector(`.comparison-value.home-team`);
        let awayTeamControl = this.shadowRoot.querySelector(`.comparison-value.away-team`);

        let homeTeamAnimation = new NumberAnimationModel(this._data.homeTeam.displayValue, homeTeamControl, this.animateNumbers);
        homeTeamAnimation.Animate(homeTeamAnimation);

        let awayTeamAnimation = new NumberAnimationModel(this._data.awayTeam.displayValue, awayTeamControl, this.animateNumbers);
        awayTeamAnimation.Animate(awayTeamAnimation);
    }

    animateNumbers(model: NumberAnimationModel) {
        model.Control.innerText = `${model.CurrentNumber}`;

        if (model.Number == 0)
            return;

        model.CurrentNumber += model.Step;

        if (model.CurrentNumber < model.Number) {
            requestAnimationFrame(function () {
                model.Animate(model);
            });
        } else if (model.CurrentNumber >= model.Number) {
            model.Control.innerText = `${model.Number}`;
            model.Control.innerText += model.Suffix;
        }
    }

    render() {
        let hightlightOptions = HighlightRule.CalculateHighlightOption(this._data.highlightRule, this._data.homeTeam, this._data.awayTeam);

        return [
            html`
            <div class="comparison-row" style="--base-color:${this._data.baseColor};--away-team-highlight-color:${this._data.awayTeam.highlightColor};--home-team-highlight-color:${this._data.homeTeam.highlightColor};--highlight-text-color:${this._data.highlightTextColor}">                        
                    <div class="column">
                        <div @click="${async (event) => await this._onClick(event, this._data.homeTeam.metricId, this._data.homeTeam.id, this._data.heading)}" 
                            class="comparison-value home-team ${(this._playlistClickThrough ? "clickable" : "")} ${(hightlightOptions.homeTeam ? "highlight" : "")}"
                            title="${this._data.heading}">0</div>
                    </div>
                    <div class="column">
                        <div class="heading">${this._data.heading}</div>
                    </div>
                    <div class="column">
                        <div @click="${async (event) => await this._onClick(event, this._data.awayTeam.metricId, this._data.awayTeam.id, this._data.heading)}" 
                            class="comparison-value away-team ${(this._playlistClickThrough ? "clickable" : "")} ${(hightlightOptions.awayTeam ? "highlight" : "")}"
                            title="${this._data.heading}">0</div>                    
                    </div>
                </div>           
            `
        ]
    }
}

window.customElements.define('number-comparison-table', NumberComparisonTable as any);